/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

export const getStallFoodData = state =>
  state && state.list && state.list.items ? state.list.items : [];
export const getStallFoodPagination = state =>
  state && state.list && state.list.pagination ? state.list.pagination : null;
export const getStallFoodLoading = state =>
  state && state.list && state.list.loading ? state.list.loading : false;
export const getStallFoodHideLoading = state =>
  state && state.list ? state.list.listHideLoading : false;
export const getFoodDetailItem = (state, foodID) =>
  state &&
  state.foodDetail &&
  state.foodDetail[foodID] &&
  state.foodDetail[foodID].item
    ? state.foodDetail[foodID].item
    : null;
export const getFoodDetailLoading = state =>
  state && state.foodDetailLoading ? state.foodDetailLoading : false;
export const getFoodReviewListData = (state, foodID) =>
  state &&
  state.foodDetail &&
  state.foodDetail[foodID] &&
  state.foodDetail[foodID].review &&
  state.foodDetail[foodID].review.items
    ? state.foodDetail[foodID].review.items
    : [];
export const getFoodReviewListPagination = (state, foodID) =>
  state &&
  state.foodDetail &&
  state.foodDetail[foodID] &&
  state.foodDetail[foodID].review &&
  state.foodDetail[foodID].review.pagination
    ? state.foodDetail[foodID].review.pagination
    : null;
export const getFoodReviewLoading = state =>
  state && state.foodReviewLoading ? state.foodReviewLoading : false;
export const getFoodReviewHideLoading = state =>
  state && state.foodReviewHideLoading ? state.foodReviewHideLoading : false;

// food
export const getFoodItemID = food => (food && food.id ? food.id : null);
export const getFoodName = food =>
  food && food.short_name ? food.short_name : null;
export const getFoodShortName = food =>
  food && food.short_name ? food.short_name : null;
export const getFoodItemDescription = food =>
  food && food.description ? food.description : null;
export const getFoodUnitPrice = food =>
  food && food.unit_price ? food.unit_price : 0;
export const getFoodEstimateWaitTime = food =>
  food && food.estimate_wait_time ? food.estimate_wait_time : null;
export const getFoodImageLargeSrc = food =>
  food && food.image && food.image.large && food.image.large.src
    ? food.image.large.src
    : null;
export const getFoodImageSmallSrc = food =>
  food && food.image && food.image.small && food.image.small.src
    ? food.image.small.src
    : null;
export const getFoodTag = food => (food && food.tag ? food.tag : []);
export const getFoodFavouriteCount = food =>
  food && food.favourite && food.favourite.count ? food.favourite.count : 0;
export const getFoodAddOn = food => (food && food.addon ? food.addon : []);
export const getFoodImages = food => (food && food.images ? food.images : []);
export const getFoodReviewCount = food =>
  food && food.review && food.review.count ? food.review.count : 0;
export const getFoodReviewRating = food =>
  food && food.review && food.review.rating ? food.review.rating : 0;
export const getFoodIsPurchasable = food =>
  food && food.attribute && food.attribute.is_purchasable
    ? food.attribute.is_purchasable
    : false;
export const getFoodIsAllowTakeAway = food =>
  food && food.attribute && food.attribute.is_allow_take_away
    ? food.attribute.is_allow_take_away
    : false;
export const getFoodIsFavourite = food =>
  food && food.attribute && food.attribute.is_favorite
    ? food.attribute.is_favorite
    : false;
export const getFoodIsReviewable = food =>
  food && food.attribute && food.attribute.is_reviewable
    ? food.attribute.is_reviewable
    : false;
export const getFoodCurrencySymbol = food =>
  food && food.currency && food.currency.symbol ? food.currency.symbol : "";
export const getFoodUnitPriceWithCurrencySymbol = food =>
  `${getFoodCurrencySymbol(food)} ${getFoodUnitPrice(food)}`;
export const getFoodPriceText = food =>
  food && food.price_text ? food.price_text : "RM 0.00";
export const getFoodTakeAwayText = food =>
  food && food.take_away && food.take_away.text ? food.take_away.text : "";
export const getFoodIsAvailable = food =>
  food && food.attribute && food.attribute.is_available
    ? food.attribute.is_available
    : false;

// food -> images
export const getFoodImageSrc = image => (image && image.src ? image.src : null);

// food -> review
export const getFoodVariant = food =>
  food && food.variant ? food.variant : [];
export const getFoodReviewID = food =>
  food && food.review && food.review.id ? food.review.id : null;



// WEBPACK FOOTER //
// ./src/selectors/food.js